import { getCurrWorkspaceAlias } from '@/utils/workspace';

import { defaultAxios } from '..';

const exportService = {
  async fetchExportHistoryList(): Promise<ExportHistoryItem[]> {
    try {
      const wa = getCurrWorkspaceAlias();
      const res = await defaultAxios.get(`/workspaces/${wa}/download_logs`);
      return res.data;
    } catch (e) {
      console.error(e);
      throw e;
    }
  },

  async getDonwloadBlob(alias: string, index: number) {
    try {
      const res = await defaultAxios.get(
        `/download_logs/${alias}/files/${index}`,
        {
          responseType: 'blob',
        },
      );

      return res.data;
    } catch (e) {
      return false;
    }
  },
};

export default exportService;
